import {RolePermissionType} from '../../backend/enums/role-permission-type';

export const MEALS_SECTOR_ID = '6335b994476dc5155f1c86ca';
export const MEALS_GROUP_ID = '646415f821d663853f279d6c';
export const BADL_SECTOR_ID = '6335b994476dc5155f1c86ca';
export const IADL_SECTOR_ID = '6464069721d663853fe82fc9';
export const CLINICAL_SUPPORT_SECTOR_ID = '646406f521d663853fe9b302';
export const PERSONAL_DEVELOPMENT_SECTOR_ID = '6464079c21d663853fec530d';

export const CLINICAL_SUPPORT__VITAL_SIGNS_ID = '64f4afc43049f191aa759487';
export const CLINICAL_SUPPORT__MEDICATION_ID = '64f4afb5d45a7856c641a98e';
export const CLINICAL_SUPPORT__HEALTH_APPOINTMENTS_ID = '64f4aef6c1af4b6758370c62';
export const CLINICAL_SUPPORT__MEDICATION__MEDICATE_ID = '64f4e736e01fde9f8b00cc4d';
export const CLINICAL_SUPPORT__NURSING_ID = '64f4afe0fe3dfac00df4e3e6';
export const CLINICAL_SUPPORT__VACCINATION_ID = '64f4aff0ea83ce54fd0ce22b';
export const CLINICAL_SUPPORT__EXAMS_ID = '67b70dfdd9c761174e46ad62';
export const CLINICAL_SUPPORT__PHYSIOTHERAPY_ID = '64f4b00041bd0d2be5843576';
export const CLINICAL_SUPPORT__SURGERY_ID = '67b723ebd9c761174e46b5d1';
export const CLINICAL_SUPPORT__OTHER_ID = '64f4b00d3e010f64278adc19';
export const PERSONAL_DEVELOPMENT__COGNITIVE_INTELLECTUAL_ID = '652587d25c9af70b16bfecc3';
export const PERSONAL_DEVELOPMENT__PHYSICS_MOVEMENT_ID = '652587e010754555b91a0add';
export const PERSONAL_DEVELOPMENT__RECREATIONAL_ARTISTIC_ID = '652588031119007d1cbe2840';
export const PERSONAL_DEVELOPMENT__SOCIAL_INTERACTION_ID = '652587c0774721148e61c4bb';
export const PERSONAL_DEVELOPMENT__OTHER_ID = '67f6a48a52db55f60db16d85';
export const PERSONAL_DEVELOPMENT__RELIGION_SPIRITUALITY_ID = '652587eafd92233616de5ea3';
export const PERSONAL_DEVELOPMENT__SOCIOCULTURAL_ID = '6525880e64994ed35c160362';
export const PERSONAL_DEVELOPMENT__DAILY_OCCUPATION_ID = '6525881911bb776348e5703d';
export const PERSONAL_DEVELOPMENT__SENSORY_ID = '65258824387015cb46e0478f';
export const BADL__FOOD_ID = '646415f821d663853f279d6c';
export const BADL__CLOTHING_ID = '646491bb21d663853f5822cb';
export const BADL__PERSONAL_HYGIENE_ID = '6464926521d663853f5c4041';
export const BADL__BATH_ID = '6464919121d663853f572a22';
export const BADL__SLEEP_ID = '6464922721d663853f5abbf5';
export const BADL__POSITION_MOBILITY_ID = '646492a221d663853f5dba62';
export const BADL__ELIMINATION_ID = '646492d121d663853f5ee4f9';
export const BADL__OTHER_ID = '64a74b9277046370801c6a13';
export const IADL__TRANSPORT_ID = '64ec79dcffb68e3f640b4d31';
export const IADL__LAUNDRY_ID = '64ed3dd0af597b2b87afe8ad';
export const IADL__HOUSEKEEPING_ID = '64dec64c06c7d4786bfe237c';
export const IADL__ESCORT_ID = '64ed40d7b7a832e71b57069d';
export const IADL__SHOPPING_ID = '64ed4545ed8967522be36514';
export const IADL__OTHER_ID = '64ed4d44f1015d0292342a8f';

export const SECTORS_IDS = [
  BADL_SECTOR_ID,
  IADL_SECTOR_ID,
  CLINICAL_SUPPORT_SECTOR_ID,
  PERSONAL_DEVELOPMENT_SECTOR_ID,
];

// !!! NOTE: This assumes sectors are the same for all entities, as specified above.
export const SECTOR_ID_TO_PERMISSION_TYPE_MAPPING: Record<string, RolePermissionType> = {
  [BADL_SECTOR_ID]: RolePermissionType.Seniors_BADL,
  [IADL_SECTOR_ID]: RolePermissionType.Seniors_IADL,
  [CLINICAL_SUPPORT_SECTOR_ID]: RolePermissionType.Seniors_ClinicalSupport,
  [PERSONAL_DEVELOPMENT_SECTOR_ID]: RolePermissionType.Seniors_PersonalDevelopment,
};

// !!! NOTE: This assumes sectors are the same for all entities, as specified above.
export const SECTOR_ID_TO_CALENDAR_PERMISSION_TYPE_MAPPING: Record<string, RolePermissionType> = {
  [BADL_SECTOR_ID]: RolePermissionType.Calendar_BADL,
  [IADL_SECTOR_ID]: RolePermissionType.Calendar_IADL,
  [CLINICAL_SUPPORT_SECTOR_ID]: RolePermissionType.Calendar_ClinicalSupport,
  [PERSONAL_DEVELOPMENT_SECTOR_ID]: RolePermissionType.Calendar_PersonalDevelopment,
};

export const MAX_LIMIT_ENTRIES = 100;
